import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@truco6/ui/tokens.css';
import './estilos.css';
import './telas.css';
import './planos.css';
import './tentos.css';
import './liga.css';
import './amigos.css';
import './plateia.css';
import './marcador.css';
import './comunidades.css';
import './campeonatos.css';
import { App } from './App.tsx';
import { lerOrigemDaUrl } from './comum/chegada.ts';
import { registrarServiceWorker } from './comum/push.ts';
import { desbloquear } from './som/som.ts';

// O navegador só libera o áudio depois de um gesto: qualquer toque ou tecla serve.
window.addEventListener('pointerdown', desbloquear, { passive: true });
window.addEventListener('keydown', desbloquear);

// ?origem=site&cta=...: guarda para o cadastro e limpa a barra de endereço antes da primeira tela.
lerOrigemDaUrl();

// O service worker faz o jogo instalável e recebe as notificações no celular.
registrarServiceWorker();

const raiz = createRoot(document.getElementById('raiz')!);
// Vitrine da mesa: só no modo de desenvolvimento; o build de produção nem leva o código.
if (import.meta.env.DEV && location.pathname === '/dev/vitrine') {
  void import('./dev/vitrine.tsx').then(({ Vitrine }) => raiz.render(<Vitrine />));
} else raiz.render(<StrictMode><App /></StrictMode>);
